import { HttpLink } from "@apollo/client";

const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_URL,
    // credentials: 'include',
})

export default httpLink